import { Box, Flex } from '@chakra-ui/react';
import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useUserInfo } from 'Store/userInfo';
import InputSelect from 'UiKit/input-select';
import FilterYearMonthPicker from 'UiKit/filter-year-month-picker';
import { useHostAchievementDetailState } from 'View/host-achievement-detail/state';

import styles from './styles.module.css';

const Filter = () => {
  const { t } = useTranslation('host-achievement');
  const { filterState, updateFilterState } = useHostAchievementDetailState();
  const { userBrand } = useUserInfo();

  const brandOptions = userBrand?.map((brand) => ({ label: brand, value: brand })) || [];

  const onChangeFilter = (newFilter) => updateFilterState({ ...newFilter });

  useEffect(() => {
    if (!isEmpty(userBrand)) {
      updateFilterState({ brand: { label: userBrand[0], value: userBrand[0] } });
    }
  }, [userBrand]); // eslint-disable-line

  return (
    <Box className={styles['filter__container']}>
      <FilterYearMonthPicker
        placeholder={'MMM YYYY'}
        width="117px"
        height="28px"
        popperPlacement="bottom-end"
        value={filterState?.yearMonth}
        dateFormat="MMM yyyy"
        onChange={(yearMonth) => updateFilterState({ yearMonth })}
      />
      <Flex justifyContent="space-between" gap="8px">
        <Box width="140px">
          <InputSelect
            value={filterState?.brand}
            options={[...brandOptions, { label: t('page.filter_all_brand'), value: 'all' }]}
            isMulti={false}
            onChange={(brand) => onChangeFilter({ brand })}
            placeholder="Brands"
            minHeight="28px"
            fontSize="var(--font-body3)"
          />
        </Box>
        <Box width="80px">
          <InputSelect
            value={filterState?.metric}
            options={[
              { label: 'AOV', value: 'aov' },
              { label: 'CTR', value: 'ctr' },
              { label: 'CTOR', value: 'ctor' },
            ]}
            isMulti={false}
            onChange={(metric) => onChangeFilter({ metric })}
            placeholder="Metrics"
            minHeight="28px"
            fontSize="var(--font-body3)"
          />
        </Box>
      </Flex>
    </Box>
  );
};

export default Filter;
